import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedCustomized = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M35.82,71.48c-19.48,0-35.33-15.85-35.33-35.33c0-19.48,15.85-35.33,35.33-35.33s35.33,15.85,35.33,35.33
		C71.15,55.63,55.3,71.48,35.82,71.48z M35.82,4.42c-17.5,0-31.73,14.23-31.73,31.73c0,17.5,14.23,31.73,31.73,31.73
		s31.73-14.23,31.73-31.73C67.55,18.65,53.31,4.42,35.82,4.42z"
                />
                <g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M35.7,58.65c-0.85,0-1.64-0.33-2.23-0.92L14.85,39.11c-1.23-1.23-1.23-3.24,0-4.47l18.62-18.62
					c0.59-0.6,1.39-0.92,2.23-0.92c0.85,0,1.64,0.33,2.23,0.92l18.62,18.62c1.23,1.23,1.23,3.24,0,4.47L37.94,57.73
					C37.34,58.32,36.55,58.65,35.7,58.65z M35.7,16.33c-0.52,0-1,0.2-1.36,0.56L15.72,35.51c-0.75,0.75-0.75,1.97,0,2.73
					l18.62,18.62c0.72,0.72,2,0.72,2.73,0l18.62-18.62c0.75-0.75,0.75-1.97,0-2.73l-7.44-7.44l0,0L37.06,16.89
					C36.7,16.53,36.22,16.33,35.7,16.33z"
                            />
                            <path
                                className={styles.cls1}
                                d="M35.7,59.25c-1.01,0-1.95-0.39-2.66-1.1L14.42,39.53c-1.47-1.47-1.47-3.85,0-5.32L33.04,15.6
					c1.42-1.42,3.9-1.42,5.32,0l18.62,18.62c1.47,1.47,1.47,3.85,0,5.32L38.36,58.15C37.65,58.86,36.71,59.25,35.7,59.25z
					 M35.7,15.7c-0.69,0-1.33,0.26-1.81,0.75L15.27,35.06c-1,1-1,2.62,0,3.62L33.89,57.3c0.96,0.96,2.66,0.96,3.62,0l18.62-18.62
					c1-1,1-2.62,0-3.62L37.51,16.44C37.03,15.96,36.39,15.7,35.7,15.7z M35.7,58L35.7,58c-0.68,0-1.33-0.26-1.79-0.72L15.29,38.66
					c-0.99-0.99-0.99-2.59,0-3.57l18.62-18.62c0.95-0.95,2.62-0.95,3.57,0l18.62,18.62c0.99,0.99,0.99,2.59,0,3.57L37.49,57.28
					C37.03,57.74,36.38,58,35.7,58z M35.7,16.93c-0.36,0-0.69,0.14-0.94,0.39L16.14,35.94c-0.52,0.52-0.52,1.36,0,1.88l18.62,18.62
					c0.23,0.23,0.58,0.37,0.94,0.37h0c0.36,0,0.7-0.13,0.94-0.37l18.62-18.62c0.52-0.52,0.52-1.36,0-1.88L36.64,17.32
					C36.39,17.07,36.06,16.93,35.7,16.93z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M32,41.19c-0.16,0-0.32-0.06-0.44-0.18c-0.24-0.24-0.24-0.63,0-0.87l7.46-7.46c0.24-0.24,0.63-0.24,0.87,0
					s0.24,0.63,0,0.87l-7.46,7.46C32.32,41.13,32.16,41.19,32,41.19z"
                            />
                            <path
                                className={styles.cls1}
                                d="M32,41.79c-0.32,0-0.63-0.13-0.86-0.36c-0.47-0.47-0.47-1.24,0-1.72l7.46-7.46c0.47-0.47,1.24-0.47,1.72,0
					c0.47,0.48,0.47,1.25,0,1.72l-7.46,7.46C32.63,41.66,32.33,41.79,32,41.79z M39.48,33.12l-7.49,7.44L32,40.59
					c0.01,0,0.01,0,0.01,0L39.48,33.12z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M24.59,48.6c-0.16,0-0.32-0.06-0.44-0.18c-0.24-0.24-0.24-0.63,0-0.87l3.31-3.31
					c0.24-0.24,0.63-0.24,0.87,0c0.24,0.24,0.24,0.63,0,0.87l-3.31,3.31C24.91,48.54,24.75,48.6,24.59,48.6z"
                            />
                            <path
                                className={styles.cls1}
                                d="M24.59,49.2c-0.32,0-0.63-0.13-0.86-0.36c-0.47-0.47-0.47-1.24,0-1.72l3.31-3.31
					c0.48-0.47,1.25-0.47,1.72,0c0.23,0.23,0.36,0.54,0.36,0.86c0,0.32-0.13,0.63-0.36,0.86l-3.31,3.31
					C25.23,49.07,24.92,49.2,24.59,49.2z M27.92,44.68l-3.33,3.29L24.59,48c0,0,0.01,0,0.01,0L27.92,44.68z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M43.06,30.13c-0.16,0-0.32-0.06-0.44-0.18c-0.24-0.24-0.24-0.63,0-0.87l3.75-3.75
					c0.24-0.24,0.63-0.24,0.87,0c0.24,0.24,0.24,0.63,0,0.87l-3.75,3.75C43.38,30.07,43.22,30.13,43.06,30.13z"
                            />
                            <path
                                className={styles.cls1}
                                d="M43.06,30.73c-0.32,0-0.63-0.13-0.86-0.36c-0.47-0.47-0.47-1.25,0-1.72l3.75-3.75
					c0.48-0.47,1.25-0.47,1.72,0c0.23,0.23,0.36,0.54,0.36,0.86c0,0.32-0.13,0.63-0.36,0.86l-3.75,3.75
					C43.69,30.6,43.39,30.73,43.06,30.73z M46.82,25.78l-3.77,3.72l0.01,0.03c0.01,0,0.01,0,0.01,0L46.82,25.78z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M39.21,40.99c-0.16,0-0.32-0.06-0.44-0.18l-7.43-7.43c-0.24-0.24-0.24-0.63,0-0.87s0.63-0.24,0.87,0
					l7.43,7.43c0.24,0.24,0.24,0.63,0,0.87C39.52,40.93,39.36,40.99,39.21,40.99z"
                            />
                            <path
                                className={styles.cls1}
                                d="M39.21,41.59c-0.33,0-0.63-0.13-0.86-0.36l-7.43-7.43c-0.47-0.48-0.47-1.25,0-1.72
					c0.23-0.23,0.54-0.36,0.86-0.36c0,0,0,0,0,0c0.32,0,0.63,0.13,0.86,0.36l7.43,7.43c0.23,0.23,0.36,0.54,0.36,0.86
					c0,0.32-0.13,0.63-0.36,0.86C39.84,41.47,39.53,41.59,39.21,41.59z M31.79,32.94l7.42,7.46c0,0,0.01,0,0.01,0L31.79,32.94z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M46.81,48.6c-0.16,0-0.32-0.06-0.44-0.18l-3.37-3.37c-0.24-0.24-0.24-0.63,0-0.87
					c0.24-0.24,0.63-0.24,0.87,0l3.37,3.37c0.24,0.24,0.24,0.63,0,0.87C47.13,48.54,46.97,48.6,46.81,48.6z"
                            />
                            <path
                                className={styles.cls1}
                                d="M46.81,49.2c-0.32,0-0.63-0.13-0.86-0.36l-3.37-3.37c-0.23-0.23-0.36-0.54-0.36-0.86
					c0-0.32,0.13-0.63,0.36-0.86c0.47-0.47,1.25-0.47,1.72,0l3.37,3.37c0.23,0.23,0.36,0.54,0.36,0.86c0,0.32-0.13,0.63-0.36,0.86
					C47.44,49.07,47.14,49.2,46.81,49.2z M43.45,44.6l3.36,3.4c0,0,0.01,0,0.01-0.01L43.45,44.6z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M28,29.79c-0.16,0-0.32-0.06-0.44-0.18l-3.41-3.41c-0.24-0.24-0.24-0.63,0-0.87s0.63-0.24,0.87,0l3.41,3.41
					c0.24,0.24,0.24,0.63,0,0.87C28.32,29.73,28.16,29.79,28,29.79z"
                            />
                            <path
                                className={styles.cls1}
                                d="M28,30.39c-0.32,0-0.63-0.13-0.86-0.36l-3.41-3.41c-0.47-0.47-0.47-1.24,0-1.72c0.48-0.48,1.25-0.47,1.72,0
					l3.41,3.41c0.47,0.48,0.47,1.25,0,1.72C28.63,30.27,28.33,30.39,28,30.39z M24.6,25.75l3.4,3.44c0.01,0,0.01,0,0.01,0
					L24.6,25.75z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M38.64,33.81c-1.35,0-2.65-0.53-3.62-1.5c-2-2-2-5.24,0-7.24c2-2,5.24-2,7.24,0
					c1.19,1.19,1.72,2.9,1.41,4.56c-0.06,0.33-0.39,0.55-0.72,0.49c-0.33-0.06-0.56-0.38-0.49-0.72c0.24-1.26-0.17-2.56-1.07-3.46
					c-1.52-1.52-3.98-1.52-5.5,0c-1.52,1.52-1.52,3.98,0,5.5c0.91,0.91,2.2,1.31,3.46,1.07c0.33-0.06,0.66,0.16,0.72,0.49
					c0.06,0.33-0.16,0.66-0.49,0.72C39.26,33.78,38.95,33.81,38.64,33.81z"
                            />
                            <path
                                className={styles.cls1}
                                d="M38.64,34.41c-1.53,0-2.96-0.6-4.04-1.68c-1.08-1.08-1.67-2.52-1.67-4.04c0-1.53,0.6-2.97,1.67-4.04
					s2.52-1.67,4.04-1.67l0,0c1.53,0,2.96,0.6,4.04,1.67c1.33,1.33,1.92,3.24,1.58,5.09c-0.12,0.66-0.75,1.1-1.42,0.97
					c-0.32-0.06-0.6-0.24-0.78-0.51c-0.18-0.27-0.25-0.59-0.19-0.91c0.2-1.07-0.14-2.16-0.91-2.93c-0.62-0.62-1.44-0.96-2.32-0.96h0
					c-0.88,0-1.7,0.34-2.32,0.96c-1.28,1.28-1.28,3.37,0,4.65c0.77,0.77,1.86,1.1,2.93,0.91c0.31-0.06,0.64,0.01,0.9,0.19
					c0.27,0.19,0.45,0.46,0.51,0.78c0.06,0.32-0.01,0.65-0.19,0.91c-0.18,0.27-0.46,0.45-0.78,0.5
					C39.34,34.37,38.99,34.41,38.64,34.41z M38.64,24.17c-1.21,0-2.34,0.47-3.2,1.32c-0.85,0.85-1.32,1.99-1.32,3.2
					s0.47,2.34,1.32,3.2c1.05,1.05,2.54,1.52,4.03,1.25c-1.47,0.24-2.96-0.23-4-1.27c-1.75-1.75-1.75-4.6,0-6.35
					c0.85-0.85,1.97-1.31,3.17-1.31c0,0,0,0,0,0c1.2,0,2.33,0.47,3.17,1.31c1.05,1.05,1.51,2.54,1.24,4
					c0.31-1.46-0.16-2.97-1.21-4.02C40.98,24.64,39.85,24.17,38.64,24.17L38.64,24.17z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M27.33,38.75c-1.31,0-2.62-0.5-3.62-1.5c-2-2-2-5.24,0-7.24c1.15-1.15,2.79-1.68,4.39-1.44
					c0.34,0.05,0.57,0.37,0.52,0.7c-0.05,0.34-0.36,0.57-0.7,0.52c-1.22-0.19-2.47,0.22-3.34,1.09c-1.52,1.52-1.52,3.98,0,5.5
					c1.52,1.52,3.98,1.52,5.5,0c0.87-0.87,1.28-2.12,1.09-3.34c-0.05-0.34,0.18-0.65,0.52-0.7c0.33-0.05,0.65,0.18,0.7,0.52
					c0.25,1.6-0.29,3.25-1.44,4.39C29.95,38.25,28.64,38.74,27.33,38.75z"
                            />
                            <path
                                className={styles.cls1}
                                d="M27.32,39.35L27.32,39.35c-1.53,0-2.97-0.59-4.04-1.67c-2.23-2.23-2.23-5.86,0-8.09
					c1.28-1.28,3.12-1.88,4.91-1.61c0.67,0.1,1.12,0.72,1.02,1.39c-0.1,0.66-0.73,1.12-1.38,1.02c-1.03-0.15-2.09,0.19-2.82,0.93
					c-1.28,1.28-1.28,3.37,0,4.65c1.28,1.28,3.37,1.28,4.65,0c0.74-0.74,1.08-1.79,0.92-2.82c-0.05-0.32,0.03-0.64,0.22-0.9
					c0.19-0.26,0.47-0.43,0.8-0.48c0.32-0.05,0.64,0.03,0.9,0.22c0.26,0.19,0.44,0.48,0.49,0.8c0.28,1.79-0.33,3.63-1.61,4.91
					C30.29,38.75,28.86,39.34,27.32,39.35z M27.26,29.13c-1.17,0-2.3,0.47-3.13,1.3c-1.76,1.76-1.76,4.63,0,6.39
					c1.71,1.71,4.69,1.7,6.39,0c1.01-1.01,1.49-2.46,1.27-3.88c0.18,1.41-0.29,2.85-1.29,3.86c-1.75,1.75-4.59,1.75-6.35,0
					c-1.75-1.75-1.75-4.6,0-6.34c1-1.01,2.44-1.48,3.85-1.26C27.76,29.15,27.51,29.13,27.26,29.13z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M32.39,50.18c-1.37,0-2.65-0.53-3.62-1.5c-1.07-1.07-1.61-2.55-1.48-4.06c0.03-0.34,0.32-0.6,0.67-0.56
					c0.34,0.03,0.59,0.33,0.56,0.67c-0.1,1.15,0.31,2.27,1.12,3.08c0.73,0.73,1.71,1.14,2.75,1.14c1.04,0,2.01-0.4,2.75-1.14
					c1.51-1.52,1.51-3.98,0-5.5c-0.81-0.81-1.94-1.22-3.08-1.12c-0.35,0.03-0.64-0.22-0.67-0.56c-0.03-0.34,0.22-0.64,0.56-0.67
					c1.51-0.13,2.99,0.41,4.06,1.48c2,2,2,5.24,0,7.24C35.04,49.65,33.76,50.18,32.39,50.18z"
                            />
                            <path
                                className={styles.cls1}
                                d="M32.39,50.78c-1.53,0-2.96-0.6-4.04-1.68c-1.2-1.19-1.8-2.85-1.65-4.54c0.03-0.33,0.19-0.63,0.44-0.84
					c0.25-0.21,0.57-0.3,0.89-0.27c0.31,0.03,0.61,0.18,0.82,0.43c0.21,0.25,0.31,0.56,0.28,0.89c-0.08,0.97,0.26,1.92,0.95,2.61
					c1.24,1.24,3.41,1.24,4.65,0c1.28-1.28,1.28-3.37,0-4.65c-0.69-0.69-1.63-1.03-2.61-0.95c-0.31,0.04-0.63-0.06-0.88-0.27
					c-0.25-0.21-0.41-0.51-0.44-0.84c-0.06-0.67,0.44-1.26,1.11-1.32c1.67-0.16,3.34,0.45,4.54,1.65c2.23,2.23,2.23,5.86,0,8.09
					C35.36,50.19,33.92,50.78,32.39,50.78z M27.92,44.67c-0.15,1.33,0.33,2.64,1.27,3.58c1.71,1.71,4.69,1.71,6.39,0
					c1.76-1.76,1.76-4.63,0-6.39c-0.95-0.95-2.24-1.42-3.58-1.31c1.32-0.08,2.62,0.39,3.56,1.33c1.75,1.75,1.75,4.6,0,6.34
					c-1.69,1.69-4.65,1.69-6.34,0C28.28,47.3,27.81,46,27.92,44.67z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M43.7,45.24c-0.1,0-0.2,0-0.3-0.01c-0.34-0.02-0.6-0.31-0.58-0.65c0.02-0.34,0.31-0.6,0.65-0.58
					c1.11,0.06,2.19-0.35,2.97-1.13c1.52-1.52,1.52-3.98,0-5.5c-1.52-1.52-3.98-1.52-5.5,0c-0.78,0.78-1.2,1.87-1.13,2.97
					c0.02,0.34-0.24,0.63-0.58,0.65c-0.34,0.02-0.63-0.24-0.65-0.58c-0.08-1.46,0.46-2.88,1.49-3.91c2-2,5.24-2,7.24,0
					c2,2,2,5.24,0,7.24C46.36,44.7,45.05,45.24,43.7,45.24z"
                            />
                            <path
                                className={styles.cls1}
                                d="M43.7,45.84c-0.11,0-0.22,0-0.33-0.01c-0.32-0.02-0.62-0.16-0.84-0.41c-0.22-0.24-0.32-0.56-0.3-0.88
					c0.04-0.66,0.6-1.18,1.28-1.14c0.96,0.06,1.86-0.3,2.52-0.96c0.62-0.62,0.96-1.45,0.96-2.33c0-0.88-0.34-1.7-0.96-2.32
					c-1.24-1.24-3.41-1.24-4.65,0c-0.66,0.66-1.01,1.58-0.96,2.51c0.04,0.67-0.48,1.25-1.14,1.29c-0.66,0.03-1.25-0.48-1.29-1.14
					c-0.09-1.63,0.51-3.22,1.67-4.37c1.08-1.08,2.52-1.67,4.04-1.67c1.53,0,2.97,0.59,4.04,1.67c1.08,1.08,1.67,2.52,1.67,4.04
					c0,1.53-0.59,2.96-1.67,4.04C46.68,45.23,45.21,45.84,43.7,45.84z M43.44,44.6c0.09,0.04,0.17,0.04,0.26,0.04
					c1.19,0,2.35-0.48,3.2-1.32c0.85-0.85,1.32-1.99,1.32-3.2c0-1.21-0.47-2.34-1.32-3.2c-1.7-1.7-4.69-1.7-6.39,0
					c-0.91,0.91-1.39,2.17-1.32,3.45c-0.04-1.28,0.43-2.53,1.34-3.43c1.69-1.69,4.65-1.7,6.35,0c0.85,0.85,1.31,1.97,1.31,3.17
					c0,1.2-0.47,2.33-1.31,3.17C45.97,44.2,44.72,44.67,43.44,44.6z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedCustomized;
